"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductsTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _ValidationMessages = require("@PetSureAustralia/petsure-react-ui-library/distLib/components/Forms/FormElements/ValidationMessages");
var _productsTableHead = require("./productsTableHead");
var _productsTableFoot = require("./productsTableFoot");
var _productsTableBody = require("./productsTableBody");
var _frequencySelector = require("../quoteControls/frequencySelector");
var _policyStartDatePicker = require("../quoteControls/policyStartDatePicker");
var _noProducts = require("../noProducts/noProducts");
var _productSummaryCardsHead = require("../productSummaryCards/productSummaryCardsHead");
var _productDDOPanel = require("./productDDOPanel");
var _productFootnotes = require("./productFootnotes");
var _tableContextHelpers = require("./stateHelpers/tableContextHelpers");
var _tableHelpers = require("../../helpers/tableHelpers");
var _tableScrollControls = require("./tableScrollControls");
var _tableContextBuilder = require("./stateHelpers/tableContextBuilder");
var _tableContext = require("./stateHelpers/tableContext");
var _tableState = require("./stateHelpers/tableState");
var _quoteHelpers = require("../../helpers/quoteHelpers");
var _staffModePreScripting = require("../staffMode/staffModePreScripting");
require("./productsTable.scss");
var _productsTableMobileLayout = require("./productsTableMobileLayout");
var _staffQuoteDetailsScript = require("../staffMode/staffQuoteDetailsScript");
var _consultationsDisclaimer = require("./consultationsDisclaimer");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable react/no-array-index-key, react/forbid-prop-types, no-console */
var ProductsTable = exports.ProductsTable = function ProductsTable(_ref) {
  var _tableLayoutConfigura, _tableProvider$tableS, _tableProvider$tableS2, _FREQUENCIES$quotesCo;
  var brand = _ref.brand,
    formContext = _ref.formContext,
    productGroupFilter = _ref.productGroupFilter,
    _ref$dataIsUpdating = _ref.dataIsUpdating,
    dataIsUpdating = _ref$dataIsUpdating === void 0 ? false : _ref$dataIsUpdating,
    _ref$staffExpertMode = _ref.staffExpertMode,
    staffExpertMode = _ref$staffExpertMode === void 0 ? false : _ref$staffExpertMode,
    _ref$tableLayoutConfi = _ref.tableLayoutConfiguration,
    tableLayoutConfiguration = _ref$tableLayoutConfi === void 0 ? undefined : _ref$tableLayoutConfi,
    _ref$staffMode = _ref.staffMode,
    staffMode = _ref$staffMode === void 0 ? false : _ref$staffMode,
    _ref$staffModeContext = _ref.staffModeContext,
    staffModeContext = _ref$staffModeContext === void 0 ? {
      brokerFriendlyName: '',
      brokerRegisteredName: '',
      tmdURL: '',
      staffName: ''
    } : _ref$staffModeContext,
    _ref$mobileMode = _ref.mobileMode,
    mobileMode = _ref$mobileMode === void 0 ? false : _ref$mobileMode,
    _ref$mobileLayout = _ref.mobileLayout,
    mobileLayout = _ref$mobileLayout === void 0 ? 'horizontal' : _ref$mobileLayout,
    _ref$petSureStaffMode = _ref.petSureStaffMode,
    petSureStaffMode = _ref$petSureStaffMode === void 0 ? false : _ref$petSureStaffMode,
    _ref$debugMode = _ref.debugMode,
    debugMode = _ref$debugMode === void 0 ? false : _ref$debugMode,
    _ref$showProductGroup = _ref.showProductGroupControls,
    showProductGroupControls = _ref$showProductGroup === void 0 ? false : _ref$showProductGroup,
    _ref$showProductSelec = _ref.showProductSelectFooters,
    showProductSelectFooters = _ref$showProductSelec === void 0 ? true : _ref$showProductSelec,
    _ref$showBaseWithoutD = _ref.showBaseWithoutDiscount,
    showBaseWithoutDiscount = _ref$showBaseWithoutD === void 0 ? true : _ref$showBaseWithoutD,
    speciesFilter = _ref.speciesFilter,
    _ref$hideProductVaria = _ref.hideProductVariants,
    hideProductVariants = _ref$hideProductVaria === void 0 ? true : _ref$hideProductVaria,
    productDefinitions = _ref.productDefinitions,
    quotesContext = _ref.quotesContext,
    productQuotes = _ref.productQuotes,
    _ref$onProductSelect = _ref.onProductSelect,
    onProductSelect = _ref$onProductSelect === void 0 ? function () {} : _ref$onProductSelect,
    _ref$onPaymentFrequen = _ref.onPaymentFrequencyChange,
    onPaymentFrequencyChange = _ref$onPaymentFrequen === void 0 ? function () {} : _ref$onPaymentFrequen,
    _ref$onPolicyStartDat = _ref.onPolicyStartDateChange,
    onPolicyStartDateChange = _ref$onPolicyStartDat === void 0 ? function () {} : _ref$onPolicyStartDat,
    beforePolicyStartDateChange = _ref.beforePolicyStartDateChange,
    _ref$onProductDDOChan = _ref.onProductDDOChange,
    onProductDDOChange = _ref$onProductDDOChan === void 0 ? function () {} : _ref$onProductDDOChan,
    _ref$onExpertModeChan = _ref.onExpertModeChange,
    onExpertModeChange = _ref$onExpertModeChan === void 0 ? function () {} : _ref$onExpertModeChan,
    _ref$validationErrors = _ref.validationErrors,
    validationErrors = _ref$validationErrors === void 0 ? {} : _ref$validationErrors,
    showFrequencySelector = _ref.showFrequencySelector,
    petIndex = _ref.petIndex,
    selectedProduct = _ref.selectedProduct,
    ageFilter = _ref.ageFilter;
  var tableScroller = (0, _react.useRef)(null);
  var tableDomElement = (0, _react.useRef)(null);
  var mobileDefaults = (_tableLayoutConfigura = tableLayoutConfiguration === null || tableLayoutConfiguration === void 0 ? void 0 : tableLayoutConfiguration.mobileDefaults) !== null && _tableLayoutConfigura !== void 0 ? _tableLayoutConfigura : {};
  var _useState = (0, _react.useState)({
      tableContext: undefined,
      tableState: _objectSpread(_objectSpread({}, _tableState.InitialTableState), {}, {
        mobileSettings: _objectSpread(_objectSpread({}, _tableState.InitialTableState.mobileSettings), mobileDefaults)
      })
    }),
    _useState2 = _slicedToArray(_useState, 2),
    tableProvider = _useState2[0],
    setTableContext = _useState2[1];
  var selectedQuote = (0, _reactHookForm.useWatch)({
    control: formContext.control,
    name: "pets.".concat(petIndex, ".selectedQuote")
  });
  var GetTableContext = (0, _react.useCallback)(function (_ref2) {
    var currentTableState = _ref2.currentTableState;
    return (0, _tableContextBuilder.TableContextBuilder)({
      currentTableState: currentTableState,
      brand: brand,
      dataIsUpdating: dataIsUpdating,
      tableLayoutConfiguration: tableLayoutConfiguration,
      hideProductVariants: hideProductVariants,
      productDefinitions: productDefinitions,
      productGroupFilter: productGroupFilter,
      productQuotes: productQuotes,
      quotesContext: quotesContext,
      showBaseWithoutDiscount: showBaseWithoutDiscount,
      showProductGroupControls: showProductGroupControls,
      speciesFilter: speciesFilter,
      staffMode: staffMode,
      staffExpertMode: staffExpertMode,
      staffModeContext: staffModeContext,
      petSureStaffMode: petSureStaffMode,
      mobileMode: mobileMode,
      selectedProduct: selectedProduct,
      selectedQuote: selectedQuote,
      petIndex: petIndex,
      ageFilter: ageFilter
    });
  }, [brand, dataIsUpdating, tableLayoutConfiguration, hideProductVariants, productDefinitions, productGroupFilter, productQuotes, quotesContext, showBaseWithoutDiscount, showProductGroupControls, speciesFilter, staffMode, staffExpertMode, staffModeContext, petSureStaffMode, mobileMode, selectedProduct, selectedQuote, petIndex, ageFilter]);
  var createNewTableState = (0, _react.useCallback)(function () {
    var _GetTableContext = GetTableContext({
        currentTableState: null
      }),
      newTableState = _GetTableContext.newTableState,
      newTableContext = _GetTableContext.newTableContext;
    setTableContext({
      tableContext: newTableContext,
      tableState: newTableState
    });
  }, [GetTableContext]);
  var visiblePlans = (_tableProvider$tableS = tableProvider === null || tableProvider === void 0 || (_tableProvider$tableS2 = tableProvider.tableState) === null || _tableProvider$tableS2 === void 0 ? void 0 : _tableProvider$tableS2.visiblePlans) !== null && _tableProvider$tableS !== void 0 ? _tableProvider$tableS : {};
  (0, _react.useEffect)(function () {
    if (brand && productDefinitions) {
      var currentTableState = tableProvider.tableState;
      var currentTableContext = tableProvider.tableContext;
      var brandHasChanged = currentTableContext && currentTableContext.brand !== brand;
      var layoutHasChanged = currentTableContext && tableLayoutConfiguration && currentTableContext.brandTextElements !== tableLayoutConfiguration;
      var groupedControlsChanged = currentTableContext && currentTableContext.showProductGroupControls !== showProductGroupControls;

      // Check if the brand has changed or a tableLayoutConfiguration has been provided
      if (brandHasChanged || layoutHasChanged || groupedControlsChanged) {
        createNewTableState();
      } else {
        var _GetTableContext2 = GetTableContext({
            currentTableState: currentTableState
          }),
          newTableState = _GetTableContext2.newTableState,
          newTableContext = _GetTableContext2.newTableContext;
        if (!(0, _helpers.ObjectsAreTheSame)(newTableState, tableProvider.tableState)) {
          if (debugMode) {
            console.debug('Table context and state updating');
          }
          setTableContext({
            tableContext: newTableContext,
            tableState: newTableState
          });
        }
      }
    }
  }, [GetTableContext, brand, productDefinitions, createNewTableState, showProductGroupControls, tableProvider, tableLayoutConfiguration, debugMode]);
  var HandleSelectedPlan = (0, _react.useCallback)(function (_ref3, key) {
    var productDefinition = _ref3.productDefinition;
    var _DeriveSelectedPlan = (0, _tableContextHelpers.DeriveSelectedPlan)({
        productDefinition: productDefinition,
        tableContext: tableProvider.tableContext,
        tableState: tableProvider.tableState
      }),
      selectedProduct = _DeriveSelectedPlan.selectedProduct,
      selectedOptions = _DeriveSelectedPlan.selectedOptions;
    var tableState = tableProvider.tableState;
    var visibilityMap = tableState.mobileSettings.visibilityMap;
    var newTableState = _objectSpread(_objectSpread({}, tableProvider.tableState), {}, {
      selectedProduct: selectedProduct,
      mobileSettings: _objectSpread(_objectSpread({}, tableProvider.tableState.mobileSettings), {}, {
        visibilityMap: _objectSpread(_objectSpread({}, visibilityMap), {}, _defineProperty({}, key, true))
      })
    });
    setTableContext({
      tableContext: tableProvider.tableContext,
      tableState: newTableState
    });
    onProductSelect({
      selectedProduct: selectedProduct,
      selectedOptions: selectedOptions
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onProductSelect, tableProvider]);
  var HandleGroupDisplayStatesChange = (0, _react.useCallback)(function (newGroupDisplayStates) {
    var newTableState = _objectSpread(_objectSpread({}, tableProvider.tableState), {}, {
      groupDisplayStates: _objectSpread({}, newGroupDisplayStates)
    });
    setTableContext({
      tableContext: tableProvider.tableContext,
      tableState: newTableState
    });
  }, [tableProvider]);
  var HandleSelectedOptionChange = (0, _react.useCallback)(function (_ref4) {
    var adjustedSelectedOptions = _ref4.adjustedSelectedOptions;
    var newTableState = _objectSpread(_objectSpread({}, tableProvider.tableState), {}, {
      selectedOptions: adjustedSelectedOptions
    });
    setTableContext({
      tableContext: tableProvider.tableContext,
      tableState: newTableState
    });
    if (debugMode) {
      console.debug('HandleSelectedOptionChange', 'adjustedSelectedOptions', adjustedSelectedOptions);
    }
    if (tableProvider.tableState.selectedProduct) {
      HandleSelectedPlan({
        productDefinition: tableProvider.tableContext.AllPlans["Plan_".concat(tableProvider.tableState.selectedProduct.planNumber)],
        adjustedSelectedOptions: adjustedSelectedOptions
      });
    }
  }, [HandleSelectedPlan, debugMode, tableProvider]);
  var handleProductDDOChange = function handleProductDDOChange(ddoRadioValue) {
    onProductDDOChange(ddoRadioValue);
    if (debugMode) {
      console.debug('ddoRadioValue', ddoRadioValue);
    }
  };
  var HandleTogglePlanVisibilityMobileMode = function HandleTogglePlanVisibilityMobileMode(key) {
    var tableState = tableProvider.tableState;
    var visibilityMap = tableState.mobileSettings.visibilityMap;
    var isVisible = visibilityMap[key];
    var newTableState = _objectSpread(_objectSpread({}, tableState), {}, {
      mobileSettings: _objectSpread(_objectSpread({}, tableState.mobileSettings), {}, {
        visibilityMap: _objectSpread(_objectSpread({}, visibilityMap), {}, _defineProperty({}, key, !isVisible))
      })
    });
    setTableContext({
      tableContext: tableProvider.tableContext,
      tableState: newTableState
    });
  };
  var HandleProductGroupChange = (0, _react.useCallback)(function (groupDetails) {
    if (debugMode) {
      console.debug('groupDetails', groupDetails);
    }
    var newTableState = _objectSpread(_objectSpread({}, tableProvider.tableState), {}, {
      selectedProduct: null,
      activeProductGroup: groupDetails
    });
    var newTableContext = _objectSpread(_objectSpread({}, tableProvider.tableContext), {}, {
      productGroupFilter: groupDetails.productsGroups
    });
    setTableContext({
      tableContext: newTableContext,
      tableState: newTableState
    });
  }, [debugMode, tableProvider]);
  if (!brand) {
    return /*#__PURE__*/_react["default"].createElement(_components.LoadingMessage, null);
  }
  if (!tableProvider.tableState.visiblePlans || !(0, _tableHelpers.HasProducts)({
    visiblePlans: tableProvider.tableState.visiblePlans
  })) {
    return /*#__PURE__*/_react["default"].createElement(_components.Spinner, null);
  }
  var getTotalPayment = function getTotalPayment() {
    var _formContext$getValue = formContext.getValues(),
      pets = _formContext$getValue.pets;
    return pets === null || pets === void 0 ? void 0 : pets.reduce(function (acc, pet) {
      var _pet$selectedQuote$to, _pet$selectedQuote;
      return acc + ((_pet$selectedQuote$to = (_pet$selectedQuote = pet.selectedQuote) === null || _pet$selectedQuote === void 0 ? void 0 : _pet$selectedQuote.totalPremiumAmount) !== null && _pet$selectedQuote$to !== void 0 ? _pet$selectedQuote$to : 0);
    }, 0);
  };
  return /*#__PURE__*/_react["default"].createElement(_tableContext.TableContext.Provider, {
    value: tableProvider
  }, /*#__PURE__*/_react["default"].createElement(_staffModePreScripting.StaffModePreScripting, {
    quotesContext: quotesContext,
    formContext: formContext,
    dataIsUpdating: dataIsUpdating,
    onPaymentFrequencyChange: onPaymentFrequencyChange,
    onExpertModeChange: onExpertModeChange
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "productTable ".concat(brand, " ").concat(staffMode ? 'staffMode' : '')
  }, /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement(_components.Spinner, null)
  }, /*#__PURE__*/_react["default"].createElement(_ValidationMessages.ValidationMessages, {
    formContext: formContext,
    name: "pets.".concat(petIndex, ".selectedQuote")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mainProductPanel"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tableScroller",
    ref: tableScroller
  }, !mobileMode && /*#__PURE__*/_react["default"].createElement(_tableScrollControls.TableScrollControls, {
    scrollingElement: tableScroller,
    tableElement: tableDomElement,
    visiblePlans: visiblePlans
  }), /*#__PURE__*/_react["default"].createElement(_productSummaryCardsHead.ProductSummaryCardsHead, null), !mobileMode && /*#__PURE__*/_react["default"].createElement("table", {
    ref: tableDomElement,
    className: "productsTable ".concat(showProductSelectFooters ? 'withSelectFooters' : '')
  }, /*#__PURE__*/_react["default"].createElement(_productsTableHead.ProductsTableHead, {
    plans: visiblePlans,
    onActiveProductGroupChange: HandleProductGroupChange,
    onPlanSelect: HandleSelectedPlan
  }), /*#__PURE__*/_react["default"].createElement(_productsTableBody.ProductsTableBody, {
    plans: visiblePlans,
    formContext: formContext,
    onSelectedOptionChange: HandleSelectedOptionChange,
    onGroupDisplayStateChange: HandleGroupDisplayStatesChange
  }), showProductSelectFooters && /*#__PURE__*/_react["default"].createElement(_productsTableFoot.ProductsTableFoot, {
    plans: visiblePlans,
    onPlanSelect: HandleSelectedPlan
  })), mobileMode && /*#__PURE__*/_react["default"].createElement(_productsTableMobileLayout.ProductsTableMobileLayout, {
    layout: mobileLayout,
    dataIsUpdating: dataIsUpdating,
    visiblePlans: visiblePlans,
    onActiveProductGroupChange: HandleProductGroupChange,
    onPlanSelect: HandleSelectedPlan,
    onSelectedOptionChange: HandleSelectedOptionChange,
    onGroupDisplayStateChange: HandleGroupDisplayStatesChange,
    onTogglePlanVisibility: HandleTogglePlanVisibilityMobileMode
  }), /*#__PURE__*/_react["default"].createElement(_consultationsDisclaimer.ConsultationsDisclaimer, null), /*#__PURE__*/_react["default"].createElement(_productFootnotes.ProductFootnotes, null)), staffMode && /*#__PURE__*/_react["default"].createElement(_staffQuoteDetailsScript.StaffQuoteDetailsScript, null), /*#__PURE__*/_react["default"].createElement(_productDDOPanel.ProductDDOPanel, {
    productDDO: tableProvider.tableContext.brandTextElements.productDDO,
    selectedProduct: tableProvider.tableState.selectedProduct,
    onConfirmation: handleProductDDOChange,
    validationErrors: validationErrors,
    formContext: formContext
  }), (typeof tableProvider.tableState.selectedProduct !== 'undefined' && showFrequencySelector || (tableLayoutConfiguration === null || tableLayoutConfiguration === void 0 ? void 0 : tableLayoutConfiguration.paymentFrequencySelector) === 'fixed' && showFrequencySelector) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_policyStartDatePicker.PolicyStartDatePicker, {
    formContext: formContext,
    policyStartDateInput: (tableLayoutConfiguration === null || tableLayoutConfiguration === void 0 ? void 0 : tableLayoutConfiguration.policyStartDateInput) || undefined,
    onPolicyStartDateChange: onPolicyStartDateChange,
    beforePolicyStartDateChange: beforePolicyStartDateChange
  }), /*#__PURE__*/_react["default"].createElement(_frequencySelector.FrequencySelector, {
    selectedFrequency: quotesContext.paymentFrequencyCode,
    collectionFee: quotesContext.collectionFee,
    dataIsUpdating: dataIsUpdating,
    formContext: formContext,
    onPaymentFrequencyChange: onPaymentFrequencyChange
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "totalPayment"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Total payment: ", (0, _helpers.FormatAsCurrency)(getTotalPayment()), "\xA0", (_FREQUENCIES$quotesCo = _quoteHelpers.FREQUENCIES[quotesContext.paymentFrequencyCode]) === null || _FREQUENCIES$quotesCo === void 0 || (_FREQUENCIES$quotesCo = _FREQUENCIES$quotesCo.frequencyDisplayText) === null || _FREQUENCIES$quotesCo === void 0 ? void 0 : _FREQUENCIES$quotesCo.toLowerCase()))), (validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.selectedProduct) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "tableValidation"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "message"
  }, "(select a plan for total value to be displayed)"))))));
};
ProductsTable.propTypes = {
  brand: _propTypes["default"].string,
  formContext: _propTypes["default"].any,
  tableLayoutConfiguration: _propTypes["default"].any,
  productGroupFilter: _propTypes["default"].string,
  dataIsUpdating: _propTypes["default"].bool,
  staffExpertMode: _propTypes["default"].bool,
  staffMode: _propTypes["default"].bool,
  staffModeContext: _propTypes["default"].shape({
    brokerFriendlyName: _propTypes["default"].string,
    brokerRegisteredName: _propTypes["default"].string,
    tmdURL: _propTypes["default"].string,
    staffName: _propTypes["default"].string
  }),
  petSureStaffMode: _propTypes["default"].bool,
  debugMode: _propTypes["default"].bool,
  mobileMode: _propTypes["default"].bool,
  mobileLayout: _propTypes["default"].oneOf(['stacked', 'horizontal']),
  showProductGroupControls: _propTypes["default"].bool,
  showProductSelectFooters: _propTypes["default"].bool,
  showBaseWithoutDiscount: _propTypes["default"].bool,
  speciesFilter: _propTypes["default"].string,
  hideProductVariants: _propTypes["default"].bool,
  productDefinitions: _propTypes["default"].any,
  productQuotes: _propTypes["default"].any,
  quotesContext: _propTypes["default"].shape(_quoteHelpers.SimplifiedQuoteContextPropTypes),
  onProductSelect: _propTypes["default"].func,
  onPaymentFrequencyChange: _propTypes["default"].func,
  onExpertModeChange: _propTypes["default"].func,
  onProductDDOChange: _propTypes["default"].func,
  onPolicyStartDateChange: _propTypes["default"].func,
  beforePolicyStartDateChange: _propTypes["default"].func,
  validationErrors: _propTypes["default"].object,
  showFrequencySelector: _propTypes["default"].bool,
  petIndex: _propTypes["default"].number,
  selectedProduct: _propTypes["default"].any,
  ageFilter: _propTypes["default"].number
};
var _default = exports["default"] = {
  ProductsTable: ProductsTable
};